require('./hireCardDiamondPackError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const { catalogue, analyticsId } = require('../analytics/hireCardDiamonPackAnalytics');

class HireCardDiamondPackError extends React.Component {

    handleGoToDocumentation() {
        this.props.history.push('/myprofile/documentation');
    }

    buildTexts() {
        const { immHireCardDiamondPack, hasAvailableAccounts, maxAllowedNumberCards, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardDiamondPack-errorTitleGeneric';
        let textElement = (
            <div className="hire-card-diamond-pack-error__text">
                <FormattedText
                    value="hireCardDiamondPack-errorTextGeneric"
                />
            </div>
        );

        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardDiamondPack-errorTitleNotAvailableAccounts';
            textElement = formatText('hireCards-errorTextNotAvailableAccounts');
        }
        else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
        }

        switch (immHireCardDiamondPack.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = 'hireCardDiamondPack-errorTitleGeneric';
                textElement = (
                    <div>
                        <div className="hire-card-diamond-pack-error__text hire-card-diamond-pack-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${immHireCardDiamondPack.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-diamond-pack-error__text">
                            <FormattedText
                                value="hireCardDiamondPack-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-diamond-pack-error__phone">
                            <i className="hire-card-diamond-pack-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardDiamondPack-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = 'hireCardDiamondPack-errorTitleRejected';
                textElement = (
                    <div>
                        <div className="hire-card-diamond-pack-error__text">
                            <FormattedText
                                value="hireCardDiamondPack-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-diamond-pack-error__phone">
                            <i className="hire-card-diamond-pack-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardDiamondPack-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = 'hireCardDiamondPack-errorTitleLowCreditScoreUpdated';
                const documentationLink = (
                    <a onClick={() => this.handleGoToDocumentation()} >
                        <FormattedText value="hireCardOpenCredit-documentation" />
                    </a>
                    );
                textElement = (
                    <div>
                        <div className="hire-card-diamond-pack-error__text hire-card-diamond-pack-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_1`}
                            />
                            {documentationLink}
                            <FormattedText
                                value={`hireCardDiamondPack-hireCardDiamondPack_lowCreditScoreMessage_updated_2`}
                            />
                        </div>
                    </div>
                );
                break;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey, hasAvailableAccounts} = this.buildTexts();
        const goBackButton =  hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:{
            label: (
                <FormattedText
                    format="uppercase"
                    value={hasAvailableAccounts ? "hireCardDiamondPack-errorBackButtonText" : "hireCards-backButtonLabel"}
                />
            ),
            url: hasAvailableAccounts ? '/myprofile/global' :  '/myprofile/cards'
        }
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.DIAMOND_PACK_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-diamond-pack-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardDiamondPackError.propTypes = {
    history: PropTypes.object.isRequired,
    immHireCardDiamondPack: PropTypes.object.isRequired,
    hasAvailableAccounts: PropTypes.bool.isRequired,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool,
};

HireCardDiamondPackError.defaultProps =
{
    hireRestrictionFlag : false
}
module.exports = withRouter(HireCardDiamondPackError);
